/* Global cart controls. BOGO pairs and Shopify-calculated totals stay authoritative. */
(function () {
  'use strict';
  if (window.bpPelsCartReady) return;
  window.bpPelsCartReady = true;
  var busy = false;
  var state = window.BarklyPaw.cartState;
  var mat = 'barklypaw-cooling-mat-1plus1';
  var gift = 52904279900477;
  var protectionHandle = 'shipping-protection';
  var timerKey = 'bp_cart_deadline_v2';
  var wasOpen = false;
  var expired = false;
  var lockedControls = [];
  var activePopup;
  var memoryDeadline = 0;
  var needsConfirmation = false;
  var routeRoot = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  function request(path, data) {
    if (data) state.invalidate();
    return fetch(routeRoot + path.replace(/^\//, ''), {method:data ? 'POST' : 'GET', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:data ? JSON.stringify(data) : undefined})
      .then(function(r) { return r.json().then(function(d) { if (!r.ok || d.status >= 400) throw new Error(d.description || 'Please try again.'); return d; }); });
  }
  function render(res) {
    var drawer = document.querySelector('cart-drawer');
    var html = res.sections && res.sections['cart-drawer'];
    if (!drawer || !html) throw new Error('Your cart was updated. Please reopen it to confirm the total.');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('.bp-cd__inner');
    if (!next) throw new Error('Please reopen your cart to confirm the total.');
    if (!res.sections['cart-icon-bubble']) throw new Error('Please reopen your cart to confirm the total.');
    needsConfirmation = false;
    state.confirm();
    var previous = drawer.querySelector('.bp-cd__inner');
    var scroll = previous.querySelector('.bp-cd__scroll') || previous.querySelector('.bp-cd__body');
    var scrollTop = scroll ? scroll.scrollTop : 0;
    var focused = previous.contains(document.activeElement);
    var insuranceFocused = focused && document.activeElement.matches('[data-bp-protection-id]');
    drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
    previous.replaceWith(next);
    var newScroll = next.querySelector('.bp-cd__scroll') || next.querySelector('.bp-cd__body');
    if (newScroll) newScroll.scrollTop = scrollTop;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && res.sections['cart-icon-bubble']) {
      var bubbleDoc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var bubbleNext = bubbleDoc.querySelector('.shopify-section');
      if (bubbleNext) bubble.innerHTML = bubbleNext.innerHTML;
    }
    // Update in place: never reopen a drawer the customer closed during a request.
    if (drawer.classList.contains('active') && typeof trapFocus === 'function') {
      trapFocus(document.getElementById('CartDrawer'), insuranceFocused ? next.querySelector('[data-bp-protection-id]') || next : next);
    }
    if (busy) lockControls();
    tick();
  }
  window.bpRenderCart = render;
  function lockControls() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('data-bp-cart-pending', 'true');
    drawer.querySelectorAll('button:not(.bp-cd__close), input').forEach(function(node) {
      if (!lockedControls.some(function(item) { return item.node === node; })) lockedControls.push({node:node, disabled:node.disabled});
      node.disabled = true;
    });
    var checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.setAttribute('aria-busy', 'true');
  }
  function unlockControls() {
    lockedControls.forEach(function(item) { item.node.disabled = item.disabled; });
    lockedControls = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.removeAttribute('data-bp-cart-pending');
      drawer.querySelectorAll('.bp-cd-update-status').forEach(function(node) { node.remove(); });
      var checkout = drawer.querySelector('#CartDrawer-Checkout');
      if (checkout) checkout.removeAttribute('aria-busy');
    }
  }
  // These capture guards run before the older bundle-removal handler.
  document.addEventListener('click', function(e) {
    if ((state.isBusy() || busy || document.querySelector('cart-drawer.bp-cart-busy')) && e.target.closest('cart-drawer') && e.target.closest('button:not(.bp-cd__close),cart-remove-button')) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function(e) {
    if ((state.isBusy() || busy || needsConfirmation || document.querySelector('cart-drawer.bp-cart-busy')) && e.target.closest('cart-drawer')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  function insuranceFeedback(row, toggle) {
    if (activePopup) activePopup.remove();
    var layer = document.querySelector('.bp-cd-fx');
    if (!layer) { layer=document.createElement('div'); layer.className='bp-cd-fx'; document.body.appendChild(layer); }
    var rect=row.getBoundingClientRect(), sw=toggle.getBoundingClientRect();
    var anchor=document.createElement('div');
    anchor.className='bp-cd-fx-anchor'; anchor.style.left=(rect.right-8)+'px'; anchor.style.top=(rect.top+2)+'px';
    var bubble=document.createElement('div'); bubble.className='bp-cd-woohoo'; bubble.setAttribute('role','status');
    bubble.textContent='Woohoo! Order protected 🎉'; anchor.appendChild(bubble); layer.appendChild(anchor); activePopup=anchor;
    setTimeout(function(){anchor.remove();if(activePopup===anchor)activePopup=null;},1600);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    row.classList.add('is-popping');
    var burst=document.createElement('div'); burst.className='bp-cd-burst'; burst.setAttribute('aria-hidden','true');
    burst.style.left=(sw.left+sw.width/2)+'px'; burst.style.top=(sw.top+sw.height/2)+'px';
    var colors=['#1fa463','#fe9a01','#ffd166','#7ad4a4','#b06400','#ffe3bb'];
    for(var i=0;i<14;i++) {
      var particle=document.createElement('i'), angle=(-155+Math.random()*130)*Math.PI/180, distance=28+Math.random()*46;
      particle.style.setProperty('--dx',(Math.cos(angle)*distance*.75)+'px'); particle.style.setProperty('--dy',(Math.sin(angle)*distance)+'px');
      particle.style.setProperty('--rot',(Math.random()*540-270)+'deg'); particle.style.background=colors[i%colors.length];
      particle.style.animationDelay=(Math.random()*90)+'ms'; if(i%3===0)particle.style.borderRadius='50%'; burst.appendChild(particle);
    }
    layer.appendChild(burst); setTimeout(function(){burst.remove();row.classList.remove('is-popping');},1100);
  }
  function recoverCart() { return state.recover(); }
  function sections() { return {sections:'cart-drawer,cart-icon-bubble',sections_url:location.pathname}; }
  function error(err) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if(el) el.textContent = err.message || "Couldn't update your cart. Please try again.";
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bp-up-add], [data-bp-set-change], [data-bp-protection-id]');
    if (!btn) return;
    e.preventDefault();
    if (busy || document.querySelector('cart-drawer.bp-cart-busy') || !state.begin()) return;
    busy = true;
    var previousError=document.getElementById('CartDrawer-CartErrors');
    if(previousError)previousError.textContent='';
    lockControls();
    if (btn.hasAttribute('data-bp-set-change')) {
      var status = document.createElement('span');
      status.className = 'bp-cd-update-status';
      status.setAttribute('role', 'status');
      status.textContent = Number(btn.dataset.bpSetChange) > 0 ? 'Adding your mats…' : 'Updating your cart…';
      btn.closest('.bp-cd-set').insertAdjacentElement('afterend', status);
    }
    var work;
    if (btn.hasAttribute('data-bp-protection-id')) {
      var desired = btn.getAttribute('aria-checked') !== 'true';
      btn.setAttribute('aria-checked', String(desired));
      if (desired) insuranceFeedback(btn.closest('.bp-cd-protection'),btn);
      var updates = {}; updates[btn.dataset.bpProtectionId] = desired ? 1 : 0;
      work = request('/cart/update.js',Object.assign(sections(),{updates:updates})).then(render).catch(function(err) {
        if(activePopup) {activePopup.remove();activePopup=null;}
        btn.setAttribute('aria-checked',String(!desired));
        return recoverCart().then(function(){throw err;},function(){
          // Do not permit checkout against an unconfirmed optimistic state.
          needsConfirmation=true;
          var checkout=document.getElementById('CartDrawer-Checkout');
          lockedControls.forEach(function(item){if(item.node===checkout)item.disabled=true;});
          throw new Error('We could not confirm the update. Please reload your cart before checkout.');
        });
      });
    } else if (btn.hasAttribute('data-bp-up-add')) {
      var card=btn.closest('[data-bp-up-id]');
      var code=card.dataset.bpUpCode;
      var addedKey;
      work=request('/cart.js').then(function(cart){
        var codes=(cart.discount_codes || []).map(function(d){return d.code;});
        if(code && !codes.some(function(c){return c.toUpperCase()===code.toUpperCase();})) codes.push(code);
        return request('/cart/add.js',{items:[{id:Number(card.dataset.bpUpId),quantity:1}]}).then(function(added){
          addedKey=added.items && added.items[0] && added.items[0].key;
          return request('/cart/update.js',Object.assign(sections(),{discount:codes.join(',')}));
        }).then(function(res){
          var applied=(res.discount_codes || []).some(function(d){return d.code.toUpperCase()===code.toUpperCase() && d.applicable;});
          if(!applied) throw new Error('This offer could not be applied with your current discounts. Please try again.');
          restartTimer();
          render(res);
        }).catch(function(err){
          if(!addedKey) throw err;
          // If the offer failed, remove the item just added instead of charging full price.
          return request('/cart.js').then(function(now){
            var line=now.items.find(function(it){return it.variant_id===Number(card.dataset.bpUpId);});
            if(!line) throw err;
            return request('/cart/change.js',Object.assign(sections(),{id:line.key,quantity:Math.max(0,line.quantity-1)})).then(function(res){render(res);throw err;});
          });
        });
      });
    } else {
      work = state.read().then(function(cart) {
        var item = cart.items.find(function(it){return it.key === btn.dataset.bpKey;});
        if(!item || item.handle !== mat) throw new Error('Your cart changed. Please reopen it and try again.');
        var delta = Number(btn.dataset.bpSetChange);
        var mats = cart.items.filter(function(it){return it.handle === mat;});
        var maxMats = Number(document.querySelector('[data-bp-max-mats]').dataset.bpMaxMats) || 2;
        if(delta > 0 && mats.reduce(function(n,it){return n+it.quantity;},0) + 2 > maxMats) throw new Error('The maximum number of sets is already in your cart.');
        var size = item.variant_options[1];
        var pair = mats.find(function(it){return it.variant_options[1] === size && it.final_line_price === 0;});
        if(!pair) throw new Error('Please reopen your cart to update this set.');
        var change = {};
        [item, pair].forEach(function(it){change[it.variant_id]=(change[it.variant_id] || 0)+delta;});
        if(delta > 0) {
          return request('/cart/add.js', Object.assign(sections(),{items:Object.keys(change).map(function(id){return {id:Number(id),quantity:change[id]};})})).then(render);
        }
        // Shopify line keys address paid/free discount splits independently.
        // Update both mats and any orphan gift in one atomic request.
        var updates = {};
        updates[item.key] = item.quantity - 1;
        updates[pair.key] = pair.quantity - 1;
        function remaining(line) {
          return Object.prototype.hasOwnProperty.call(updates, line.key) ? updates[line.key] : line.quantity;
        }
        if (!mats.some(function(line) { return remaining(line) > 0; })) {
          cart.items.forEach(function(line) { if (line.variant_id === gift) updates[line.key] = 0; });
        }
        if (!cart.items.some(function(line) { return line.variant_id !== gift && line.handle !== protectionHandle && remaining(line) > 0; })) {
          cart.items.forEach(function(line) { if (line.handle === protectionHandle) updates[line.key] = 0; });
        }
        return request('/cart/update.js', Object.assign(sections(), {updates:updates})).then(render);
      });
    }
    work.catch(function(err) {
      return recoverCart().then(function() { error(err); }, function(recoveryError) { needsConfirmation=true; error(recoveryError); });
    }).finally(function(){busy=false;unlockControls();state.end();cleanProtection();});
  });

  function restartTimer() {
    expired=false; memoryDeadline=Date.now()+240000;
    try {sessionStorage.setItem(timerKey,String(memoryDeadline));}catch(e){}
  }
  function tick() {
    var drawer=document.querySelector('cart-drawer');
    var inner=drawer && drawer.querySelector('[data-bp-merch-count]');
    if(inner && Number(inner.dataset.bpMerchCount)===0) {
      memoryDeadline=0; wasOpen=false; expired=false;
      try {sessionStorage.removeItem(timerKey);}catch(e){}
      return;
    }
    var clock=document.querySelector('[data-bp-countdown-clock]');
    var open=!!drawer && drawer.classList.contains('active');
    if(!open || !clock) {wasOpen=false;return;}
    var deadline=memoryDeadline;
    try { deadline=Number(sessionStorage.getItem(timerKey)) || memoryDeadline; } catch(e) {}
    if(!deadline || (!wasOpen && deadline<=Date.now())) { deadline=Date.now()+240000; expired=false; try {sessionStorage.setItem(timerKey,String(deadline));}catch(e){} }
    memoryDeadline=deadline; wasOpen=true;
    var seconds=Math.max(0,Math.ceil((deadline-Date.now())/1000));
    var text=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
    if(clock.textContent!==text) clock.textContent=text;
    if(seconds===0 && !expired && !state.isBusy() && !busy && !needsConfirmation && !drawer.classList.contains('bp-cart-busy')) {
      expired=true;
      memoryDeadline=0;
      try {sessionStorage.removeItem(timerKey);}catch(e){}
      location.assign(routeRoot+'checkout');
    }
  }
  function cleanProtection() {
    var inner=document.querySelector('[data-bp-merch-count]');
    if(!inner || state.isBusy() || busy || needsConfirmation) return;
    if(Number(inner.dataset.bpMerchCount)===0) {
      memoryDeadline=0;
      try {sessionStorage.removeItem(timerKey);}catch(e){}
      if(inner.dataset.bpProtectionKey && state.begin()) {
        busy=true; lockControls();
        request('/cart/change.js',Object.assign(sections(),{id:inner.dataset.bpProtectionKey,quantity:0})).then(render).catch(function(err){needsConfirmation=true;error(err);}).finally(function(){busy=false;unlockControls();state.end();});
      }
    }
  }
  function boot() {
    var drawer=document.querySelector('cart-drawer');
    if(!drawer) return;
    var observer=new MutationObserver(function(){tick();cleanProtection();});
    observer.observe(drawer,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
    tick();cleanProtection();setInterval(tick,1000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);else boot();
})();
